/* MacDanny Fashion — theme scripts (no dependencies) */
(function () {
  'use strict';

  var routes = (window.MD && window.MD.routes) || {};
  var strings = (window.MD && window.MD.strings) || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------------- Drawers ---------------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    var f = d.querySelector('[data-drawer-close]');
    if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('overflow-hidden');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer);
    var sm = $('.search-modal.is-open');
    if (sm) closeSearch();
    $$('details.nav-dd[open]').forEach(function (d) { d.removeAttribute('open'); });
  });
  // Close desktop dropdown when clicking elsewhere
  document.addEventListener('click', function (e) {
    $$('details.nav-dd[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  /* ---------------- Search ---------------- */
  function openSearch() {
    var m = $('#search-modal'); if (!m) return;
    m.classList.add('is-open'); document.body.classList.add('overflow-hidden');
    var i = $('input[type="search"]', m); if (i) setTimeout(function () { i.focus(); }, 30);
  }
  function closeSearch() {
    var m = $('#search-modal'); if (!m) return;
    m.classList.remove('is-open');
    if (!$('.drawer.is-open')) document.body.classList.remove('overflow-hidden');
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); return; }
    if (e.target.closest('[data-search-close]') || e.target.id === 'search-modal') { closeSearch(); }
  });
  var searchTimer;
  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-predictive-search]');
    if (!input) return;
    clearTimeout(searchTimer);
    var q = input.value.trim();
    var box = $('[data-predictive-results]');
    if (!box) return;
    if (q.length < 2) { box.innerHTML = ''; return; }
    searchTimer = setTimeout(function () {
      fetch((routes.predictive_search_url || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var items = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!items.length) { box.innerHTML = '<p class="body-copy">' + (strings.noResults || 'No products found.') + '</p>'; return; }
          box.innerHTML = items.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '<span style="width:52px;height:52px;background:var(--sunken);display:block"></span>';
            return '<a class="search-result" href="' + p.url + '">' + img + '<span><span style="display:block;font-size:14px;font-weight:500">' + p.title + '</span><span class="price" style="font-size:13px">' + formatMoney(p.price) + '</span></span></a>';
          }).join('');
        }).catch(function () {});
    }, 220);
  });

  function formatMoney(value) {
    var n = Number(value);
    if (isNaN(n)) return value;
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: (window.MD && window.MD.currency) || 'USD' }).format(n); }
    catch (e) { return '$' + n.toFixed(2); }
  }

  /* ---------------- Cart (AJAX + Section Rendering API) ---------------- */
  function renderCartSections(sections) {
    if (!sections) return;
    var html = sections['cart-drawer'];
    if (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer-inner]');
      var cur = $('[data-cart-drawer-inner]');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      var count = fresh ? parseInt(fresh.getAttribute('data-count') || '0', 10) : null;
      if (count !== null) updateCount(count);
    }
  }
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }
  function cartPost(url, body) {
    body.sections = ['cart-drawer'];
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) { var err = new Error(data.description || data.message || 'Error'); err.data = data; throw err; }
        return data;
      });
    });
  }
  function addToCart(items, button) {
    var label = button ? button.querySelector('[data-label]') : null;
    var original = label ? label.textContent : '';
    if (button) { button.setAttribute('aria-busy', 'true'); button.disabled = true; }
    return cartPost(routes.cart_add_url + '.js', { items: items })
      .then(function (data) {
        renderCartSections(data.sections);
        openDrawer('cart-drawer');
        if (label) {
          label.textContent = button.getAttribute('data-added-text') || strings.added || 'Added';
          setTimeout(function () { label.textContent = original; }, 1400);
        }
        return data;
      })
      .catch(function (err) {
        var box = button && button.closest('form') ? button.closest('form').querySelector('[data-form-error]') : null;
        if (box) { box.textContent = err.message; box.hidden = false; }
        else alert(err.message);
      })
      .finally(function () { if (button) { button.removeAttribute('aria-busy'); button.disabled = false; } });
  }
  window.MDaddToCart = addToCart;

  // Quick add buttons on product cards
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    addToCart([{ id: Number(btn.getAttribute('data-quick-add')), quantity: 1 }], btn);
  });

  // Product forms
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var err = form.querySelector('[data-form-error]'); if (err) err.hidden = true;
    var id = form.querySelector('[name="id"]').value;
    var qtyEl = form.querySelector('[name="quantity"]');
    var qty = qtyEl ? Math.max(1, parseInt(qtyEl.value || '1', 10)) : 1;
    addToCart([{ id: Number(id), quantity: qty }], form.querySelector('[type="submit"]'));
  });

  // Cart drawer quantity / remove
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-line]');
    if (!btn) return;
    e.preventDefault();
    var wrap = $('[data-cart-drawer-inner]');
    if (wrap) wrap.classList.add('is-loading');
    cartPost(routes.cart_change_url + '.js', { line: Number(btn.getAttribute('data-cart-line')), quantity: Number(btn.getAttribute('data-qty')) })
      .then(function (data) { renderCartSections(data.sections); updateCount(data.item_count); })
      .catch(function (err) { alert(err.message); })
      .finally(function () { var w = $('[data-cart-drawer-inner]'); if (w) w.classList.remove('is-loading'); });
  });

  /* ---------------- Quantity steppers ---------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    e.preventDefault();
    var input = b.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var v = parseInt(input.value || '1', 10) + parseInt(b.getAttribute('data-qty-step'), 10);
    input.value = Math.max(parseInt(input.min || '1', 10), v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Hero slideshow ---------------- */
  $$('[data-hero]').forEach(function (hero) {
    var slides = $$('[data-hero-slide]', hero);
    var dots = $$('[data-hero-dot]', hero);
    if (slides.length < 2) return;
    var i = 0, delay = parseInt(hero.getAttribute('data-interval') || '5200', 10), timer;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function start() { stop(); timer = setInterval(function () { go(i + 1); }, delay); }
    function stop() { clearInterval(timer); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); start(); }); });
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
  });

  /* ---------------- Reviews rail ---------------- */
  $$('[data-rail]').forEach(function (wrap) {
    var rail = $('[data-rail-track]', wrap);
    function step(dir) {
      var card = rail.firstElementChild;
      var gap = parseFloat(getComputedStyle(rail).columnGap || '24') || 24;
      var w = card ? card.getBoundingClientRect().width + gap : rail.clientWidth / 3;
      rail.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    var p = $('[data-rail-prev]', wrap), n = $('[data-rail-next]', wrap);
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
  });

  /* ---------------- Collection filters ---------------- */
  document.addEventListener('change', function (e) {
    var form = e.target.closest('form[data-facets-form]');
    if (!form) return;
    if (e.target.matches('[data-price-input]')) return; // price submits on blur/enter
    submitFacets(form);
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-price-input]')) return;
    submitFacets(e.target.closest('form'));
  });
  function submitFacets(form) {
    var params = new URLSearchParams(new FormData(form));
    // drop empty values
    Array.from(params.keys()).forEach(function (k) { if (!params.get(k)) params.delete(k); });
    var sort = $('[data-sort-select]');
    if (sort && sort.value && !params.has('sort_by')) params.set('sort_by', sort.value);
    window.location.search = params.toString();
  }
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-sort-select]')) return;
    var params = new URLSearchParams(window.location.search);
    params.set('sort_by', e.target.value);
    params.delete('page');
    window.location.search = params.toString();
  });

  /* ---------------- Product page ---------------- */
  $$('[data-product]').forEach(function (root) {
    var jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = $('form[data-product-form]', root);
    var idInput = form ? $('[name="id"]', form) : null;
    var priceEl = $('[data-price]', root);
    var btn = form ? $('[type="submit"]', form) : null;
    var btnLabel = btn ? $('[data-label]', btn) : null;
    var mainImg = $('.pdp__main-img', root);
    var thumbs = $$('[data-thumb]', root);
    var sticky = $('[data-sticky-atc]');

    function setImage(src, srcset, id) {
      if (!mainImg || !src) return;
      mainImg.src = src; if (srcset) mainImg.srcset = srcset;
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-media-id') === String(id)); });
      var s = sticky && $('img', sticky); if (s) s.src = src;
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        setImage(t.getAttribute('data-src'), t.getAttribute('data-srcset'), t.getAttribute('data-media-id'));
      });
    });

    function selectedOptions() {
      return $$('[data-option-index]', root).map(function (fs) {
        var c = $('input:checked', fs); return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function update() {
      var opts = selectedOptions();
      $$('[data-option-index]', root).forEach(function (fs, i) {
        var lbl = $('[data-option-value]', fs); if (lbl) lbl.textContent = opts[i] || '';
      });
      var v = findVariant(opts);
      if (!v) {
        if (btn) { btn.disabled = true; if (btnLabel) btnLabel.textContent = strings.unavailable || 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        var html = formatMoney(v.price / 100);
        if (v.compare_at_price && v.compare_at_price > v.price) html += ' <s>' + formatMoney(v.compare_at_price / 100) + '</s>';
        priceEl.innerHTML = html;
        $$('[data-sticky-price]').forEach(function (el) { el.textContent = formatMoney(v.price / 100); });
      }
      if (btn) {
        btn.disabled = !v.available;
        if (btnLabel) btnLabel.textContent = v.available ? (strings.addToBag || 'Add to bag') : (strings.soldOut || 'Sold out');
      }
      if (v.featured_media) {
        var t = thumbs.find(function (x) { return x.getAttribute('data-media-id') === String(v.featured_media.id); });
        if (t) setImage(t.getAttribute('data-src'), t.getAttribute('data-srcset'), v.featured_media.id);
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    root.addEventListener('change', function (e) { if (e.target.closest('[data-option-index]')) update(); });

    // Sticky ATC triggers main form
    if (sticky) {
      var sb = $('[data-sticky-add]', sticky);
      if (sb && form) sb.addEventListener('click', function (e) { e.preventDefault(); form.requestSubmit ? form.requestSubmit() : form.submit(); });
    }

    // Recently viewed
    try {
      var key = 'md-recently-viewed';
      var list = JSON.parse(localStorage.getItem(key) || '[]').filter(function (h) { return h !== product.handle; });
      list.unshift(product.handle);
      localStorage.setItem(key, JSON.stringify(list.slice(0, 9)));
    } catch (e) {}
  });

  /* ---------------- Product recommendations ---------------- */
  $$('[data-recommendations]').forEach(function (el) {
    fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
      else if (el.closest('section')) el.closest('section').hidden = true;
    }).catch(function () {});
  });

  /* ---------------- Recently viewed ---------------- */
  $$('[data-recently-viewed]').forEach(function (section) {
    var current = section.getAttribute('data-current');
    var handles = [];
    try { handles = JSON.parse(localStorage.getItem('md-recently-viewed') || '[]'); } catch (e) {}
    handles = handles.filter(function (h) { return h !== current; }).slice(0, 4);
    if (!handles.length) return;
    var grid = $('[data-recently-grid]', section);
    Promise.all(handles.map(function (h) {
      return fetch((routes.root_url || '/').replace(/\/$/, '') + '/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      items = items.filter(Boolean);
      if (!items.length) return;
      grid.innerHTML = items.map(function (p) {
        var img = p.featured_image ? '<img src="' + p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600" alt="" loading="lazy">' : '';
        return '<a class="mini-card" href="' + p.url + '"><div class="media media--square">' + img + '</div><p class="mini-card__name">' + p.title + '</p><p class="mini-card__price">' + formatMoney(p.price / 100) + '</p></a>';
      }).join('');
      section.hidden = false;
    });
  });

  /* ---------------- Newsletter / contact success scroll ---------------- */
  if (window.location.hash === '#newsletter' || window.location.search.indexOf('customer_posted=true') > -1) {
    var n = document.getElementById('newsletter'); if (n) n.scrollIntoView();
  }
})();
